import InlineError from "@components/forms/InlineError";

function HomeLocalizedField({
  label = "",
  fieldName = "",
  activeLanguageIso = "",
  value = "",
  onChange,
  onBlur,
  error = "",
  multiline = false,
  placeholder = "",
}) {
  const inputProps = {
    className: "field-input",
    value,
    placeholder,
    onChange: (event) =>
      onChange?.(fieldName, activeLanguageIso, event.target.value),
    onBlur: () => onBlur?.(fieldName, activeLanguageIso),
  };

  return (
    <div className="tour-add-form-group">
      <p className="tour-add-form-label">
        {label}
        {error ? <InlineError>{error}</InlineError> : null}
      </p>
      <label className="field-label app-form-field">
        {multiline ? (
          <textarea {...inputProps} rows={5} />
        ) : (
          <input {...inputProps} type="text" />
        )}
      </label>
    </div>
  );
}

export default HomeLocalizedField;
